import { Page } from "components/Page";

export const CGU: React.FC = () => {
  return (
    <Page title={"CGU"}>
      <embed
        src={`/help/CGU.pdf`}
        type="application/pdf"
        width="100%"
        height="100%"
      ></embed>
    </Page>
  );
};
